export { DeleteProjectionsSelect, DeleteProjectionOriginType } from './lib/delete-projections-select';
